export const normalizeLicensePlate = (value) => {
  if (!value) {
    return value;
  }
  return value.toUpperCase().replace(/[^A-Z0-9]+/g, "");
};
